import { axiosInstance, API_PREFIX, type ApiResponse, type RequestParams } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import type {
  CategoryBase,
  CategoryById,
  CategoryCreatePayload,
  CategoryUpdatePayload,
  CategoryItem,
  CategoryItemListParams,
} from '../model/types';

export const getList = async (params?: RequestParams): Promise<ApiResponseList<CategoryBase>> => {
  const { data } = await axiosInstance.get<ApiResponseList<CategoryBase>>(`${API_PREFIX.ADMIN_V1}/category/index`, {
    params,
  });

  return data;
};

export const getById = async (id: number): Promise<ApiResponse<CategoryById>> => {
  const { data } = await axiosInstance.get<ApiResponse<CategoryById>>(`${API_PREFIX.ADMIN_V1}/category/show`, {
    params: { id },
  });

  return data;
};

export const getItemList = async (params?: CategoryItemListParams): Promise<ApiResponse<CategoryItem[]>> => {
  const { data } = await axiosInstance.get<ApiResponse<CategoryItem[]>>(`${API_PREFIX.ADMIN_V1}/category/item-list`, {
    params: params,
  });

  return data;
};

export const create = async (payload: CategoryCreatePayload): Promise<ApiResponse<CategoryById>> => {
  const { data } = await axiosInstance.post<ApiResponse<CategoryById>>(
    `${API_PREFIX.ADMIN_V1}/category/create`,
    payload
  );

  return data;
};

export const update = async (payload: CategoryUpdatePayload): Promise<ApiResponse<CategoryById>> => {
  const { data } = await axiosInstance.post<ApiResponse<CategoryById>>(
    `${API_PREFIX.ADMIN_V1}/category/update`,
    payload
  );

  return data;
};

export const remove = async (id: number): Promise<ApiResponse<null>> => {
  const { data } = await axiosInstance.post<ApiResponse<null>>(`${API_PREFIX.ADMIN_V1}/category/delete`, { id });

  return data;
};
